import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SelectionModel } from 'src_common/common/websocket2/models/SelectionModel/SelectionModel';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { MarketModel } from 'src_common/common/websocket2/models/MarketModel';
import { RacecardRaceRouteType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import { RaceSliderGrList } from 'src/domains/sportsbook/webview/components/raceSliderItemV1/greyhoundRacing/RaceBoxHr.style';
import { CardHeader } from 'src/domains/sportsbook/webview/components/raceSliderItemV1/shared/cardHeader/CardHeader';
import { CardBody } from 'src/domains/sportsbook/webview/components/raceSliderItemV1/greyhoundRacing/cardBody/CardBody';
import { CardFooter } from 'src/domains/sportsbook/webview/components/raceSliderItemV1/shared/cardFooter/CardFooter';

export interface RaceSliderGrPropsType {
    race: EventModel;
    market: MarketModel;
    sortSelections: (list: Array<SelectionModel>) => Array<SelectionModel>;
}

export const RaceSliderGr = observer('RaceSliderGr', (props: RaceSliderGrPropsType) => {
    const { race, market, sortSelections } = props;

    const routingData: RacecardRaceRouteType = {
        collection: race.competition2.toOldId(),
        name: 'racecard',
        selected: race.id2.toOldId(),
        sport: race.sport,
    };

    return (
        <RaceSliderGrList key='race-box-selections'>
            <CardHeader
                race={race}
                routingData={routingData}
            />
            <CardBody
                market={market}
                sortSelections={sortSelections}
            />
            <CardFooter routingData={routingData} />
        </RaceSliderGrList>
    );
});
